import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { stateInscriptionEndpoint } from 'Services/Apis/clients';

export const ValidateIe = async (user, doc, uf ) => {
  return stateInscriptionEndpoint(user).get(
      `/sintegra/getValidateIe/${doc}/uf/${uf}`
  );
}
export const GetValidateIe = createAsyncThunk(
  'StateInscription/GetValidateIe',
  async (payload, { getState, rejectWithValue, fulfillWithValue }) => {
    try {
      const state = getState();
      const { oidc } = state;
      const response = await ValidateIe(oidc.user, payload.document, payload.uf)
      return response.data;
    } catch (error) {
      if (error.code == "ERR_NETWORK") {
        //Houve um erro de conexão e não de validação da API, nesse caso não podemos bloquear o resgate
        var responseError = { error: "400000", message: "Houve um erro na API" };
        throw rejectWithValue(responseError);
      }
      throw rejectWithValue(error.response.data);
    }
  },
);

const initialState = {
  stateInscriptionIsLoading: false,
  stateInscriptionData: 0,
  stateInscriptionError: true,
  stateInscriptionErrorCode: "",
  stateInscriptionErroMsg: "",
  stateInscriptionFullfiled: false,
  stateInscriptionShouldBlock: false
};

const ValidateIeSlice = createSlice({
  name: 'validateIeSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetValidateIe.pending, (state) => {
        state.stateInscriptionIsLoading = true;
        state.stateInscriptionError = false;
        state.stateInscriptionFullfiled = false;
        state.stateInscriptionShouldBlock = false;
      })
      .addCase(GetValidateIe.fulfilled, (state, { payload }) => {
        state.stateInscriptionIsLoading = false;
        state.stateInscriptionData = payload.data.ie;
        state.stateInscriptionError = false;
        state.stateInscriptionFullfiled = true;
        state.stateInscriptionShouldBlock = false;
      })
      .addCase(GetValidateIe.rejected, (state, { payload }) => {
        state.stateInscriptionIsLoading = false;
        state.stateInscriptionData = 0;
        state.stateInscriptionError = true;
        state.stateInscriptionErrorCode = payload.error;
        state.stateInscriptionErroMsg = payload.message;
        state.stateInscriptionFullfiled = true;

        if (payload.error == "400002" || payload.error == "400003" || payload.error == "400004") {
          state.stateInscriptionShouldBlock = true;
        }
        else {
          state.stateInscriptionShouldBlock = false;
        }
      })
  },
});

export default ValidateIeSlice.reducer;
